import { FC } from "react"

export const SidebarHeader : FC = () => {
    return (
        <></>
    );
};